import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { Queue, State } from '@switchboard-xyz/on-demand';

export default class GuardianRegister extends SolanaWithSignerBaseCommand {
  static description = 'register or deregister a guardian on a queue';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    guardian: Flags.string({
      description: 'new guardian account to register',
      required: true,
    }),
    disable: Flags.boolean({
      description: 'disable the specified guardian',
    }),
  };

  static args = {};

  async run() {
    // == begin flags&opts - setup and parse flags and default options
    const { flags } = await this.parse(
      this.constructor as typeof GuardianRegister
    );

    const program = await this.program;

    const state = new State(program);
    const stateData = await state.loadData();

    const latestBlockhash =
      await this.connection.getLatestBlockhash('confirmed');
    console.log(
      '✅ - Fetched latest blockhash. Last Valid Height:',
      latestBlockhash.lastValidBlockHeight
    );

    // == begin queue - build queue and oracle objects
    const queueAccount = new Queue(
      program,
      new web3.PublicKey(stateData.guardianQueue)
    );
    if (this.verbose) {
      console.log(`Queue pubkey: ${queueAccount.pubkey}`);
    }
    // == end queue

    // == begin authority - check that the queueAuthority is the same as the specified keypair
    const queueData = await queueAccount.loadData();
    const queueAuthority = queueData.authority;
    if (this.verbose) {
      console.log(`Queue authority : ${queueAuthority}`);
    }

    // == begin isGuardian - check if Guardian
    const guardianPubkey = new web3.PublicKey(flags.guardian);
    if (this.verbose) {
      console.log(`Guardian Pubkey used: ${guardianPubkey}`);
    }

    // set native Program auth
    const nativeProgramAuth = '11111111111111111111111111111111';

    if (queueAuthority.toString() !== nativeProgramAuth.toString()) {
      // native programs' auth is always '111111...'
      console.log(
        'ERROR: guardian specifed is not linked to the switchboard guardian queue'
      );
      console.log(
        'Please use the `solana on-demand permission set` command for Oracles.'
      );
      return;
    }
    // == end isGuardian

    // == begin ix - craft the ix

    const ix = await (flags.disable
      ? state.unregisterGuardianIx({ guardian: guardianPubkey })
      : state.registerGuardianIx({ guardian: guardianPubkey }));

    if (this.verbose) {
      console.log('  Adding the instruction below to the transaction:');
      console.log(
        `  Clear-text instruction: ${JSON.stringify(ix, this.jsonReplacers, 2)}`
      );
    }
    // == end ix

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to set permission');
  }
}
